import quantityId from '../enums/quantityId.js';
import Quantity from '../entities/quantity.js';
import Unit from '../entities/unit.js';

const area = new Quantity(
    quantityId.AREA,
    'Area'
);

area.registerUnit(
    new Unit(
        'ft2', 10.764262648009, 'square foot', [
            "ft²", "ft^2", "'²", "′²", "'^2", "′^2"
        ]
    )
);

area.registerUnit(
    new Unit(
        'm2', 1, 'square metre', [
            "m²", "m^2"
        ]
    )
);

area.registerUnit(
    new Unit(
        'yd2', 1.1960291831121, 'square yard', [
            "yd²", "yd^2", "yds²", "yds^2"
        ]
    )
);

export default area;